import Landing from "layouts/landing";
import QRGenerator from "layouts/qrgenerator";
import ProceduralLand from "layouts/proceduralLand"
import RandomStringGenerator from "layouts/randomStringGenerator"

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Landing",
    key: "Landing",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/landing",
    component: <Landing />,
  },
  {
    type: "collapse",
    name: "QR generator",
    key: "QRGenerator",
    icon: <Icon fontSize="small">qr_code</Icon>,
    route: "/QRGenerator",
    component: <QRGenerator />,
  },
  {
    type: "collapse",
    name: "Procedural terrain",
    key: "ProceduralLand",
    icon: <Icon fontSize="small">terrain_icon</Icon>,
    route: "/ProceduralLand",
    component: <ProceduralLand />,
  },
  {
    type: "collapse",
    name: "string generator",
    key: "RandomStringGenerator",
    icon: <Icon fontSize="small">abc</Icon>,
    route: "/RandomStringGenerator",
    component: <RandomStringGenerator />,
  }
];

export default routes;
